import React, { Component } from 'react'

export class FeaturesTop extends Component {
    render() {
        return (
            <div className='features__top'>
                {/* Features title */}
                <h3 className='features__title'>Powerful simplicity</h3>
                {/* Features sub-title */}
                <h4 className='features__title--sub'>Enter the future of farming</h4>
            </div>
        )
    }
}

export default FeaturesTop